import { useEffect, useState } from "react";
import { MonitorDown, X } from "lucide-react";

let deferredPrompt = null;
window.addEventListener("beforeinstallprompt", (e) => {
  e.preventDefault();
  deferredPrompt = e;
  window.dispatchEvent(new CustomEvent("pwa-installable"));
});

export function InstallBanner() {
  const [ready, setReady] = useState(!!deferredPrompt);
  const [hidden, setHidden] = useState(() => localStorage.getItem("pwa_banner_dismissed") === "1");
  useEffect(() => {
    const on = () => setReady(true);
    const done = () => { deferredPrompt = null; setReady(false); };
    window.addEventListener("pwa-installable", on);
    window.addEventListener("appinstalled", done);
    return () => { window.removeEventListener("pwa-installable", on); window.removeEventListener("appinstalled", done); };
  }, []);
  if (!ready || hidden) return null;
  const install = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    await deferredPrompt.userChoice;
    deferredPrompt = null;
    setReady(false);
  };
  const dismiss = () => { localStorage.setItem("pwa_banner_dismissed", "1"); setHidden(true); };
  return (
    <div className="fixed bottom-4 right-4 z-[80] max-w-xs rounded-xl shadow-2xl border border-white/10 overflow-hidden"
         style={{ background: "linear-gradient(135deg, #3B82F6 0%, #3B82F6 100%)" }} data-testid="install-banner">
      <div className="p-4">
        <div className="flex items-start gap-3">
          <span className="w-9 h-9 rounded-lg bg-white/10 flex items-center justify-center flex-none">
            <MonitorDown size={17} className="text-[#FC5F5F]" />
          </span>
          <div className="min-w-0">
            <div className="text-sm font-semibold text-white">Install Hi-Tech CRM</div>
            <div className="text-[11px] text-white/60 mt-0.5 leading-snug">Opens like an app, works offline, right from your home screen or desktop.</div>
          </div>
          <button onClick={dismiss} className="text-white/40 hover:text-white -mt-1 -mr-1 p-1" data-testid="install-dismiss"><X size={14} /></button>
        </div>
        <button onClick={install} data-testid="install-confirm"
                className="mt-3 w-full text-xs font-semibold tracking-wide uppercase bg-[#FC5F5F] hover:bg-[#e35353] text-white rounded-lg py-2 transition-colors">
          Install App
        </button>
      </div>
    </div>
  );
}
